// extracted by mini-css-extract-plugin
export default {"modal-prompt-errors":"ModalPromptErrors_modal-prompt-errors__EwW9L"};